<div class="navbar-header">

  <div class="logo">
    <a class="link" id="main_logo_link"
      tabindex="0"
      appFocusBoundary
      [prevId]="'skiptocontent_link'"
      [nextId]="'togglemenutabgestion'"
      role="link" (click)="navigate()"
      data-e2e="style-2-navigate"
      (keydown.enter)="navigate()">
      @if (!brandLogoSvg) {
        <img class="logo-icon-png" src="assets/{{ brand }}/images/logos/{{isGar?'brand_gar':'brand'}}.png" alt="">
      }
      @if (brandLogoSvg && !useBrandTwoDifferentSvg) {
        <mat-icon class="logo-icon-svg" svgIcon="brand"></mat-icon>
      }
      <!--to use if you need different icon menu closed and open and different of login menu icon-->
      @if (brandLogoSvg && useBrandTwoDifferentSvg) {
        <mat-icon id="brand_large" class="logo-icon-svg"
        svgIcon="brand_menu_large"></mat-icon>
      }
      @if (brandLogoSvg && useBrandTwoDifferentSvg) {
        <mat-icon id="brand_icon_small" class="logo-icon-svg"
        svgIcon="brand_menu"></mat-icon>
      }

      <span class="logo-text">{{ brand }}</span>
    </a>
  </div>
  <button id="togglemenutabgestion"  aria-controls="navbar-vertical-2" mat-icon-button class="toggle-sidebar-folded"  [attr.aria-label]="(isFolded?'generic.menu_unfold':'generic.menu_fold') | translate" [attr.aria-expanded]="!isFolded" title="Toggle menu" tabindex="0"
    (click)="toggleSidebarFolded()" data-e2e="stye-2-folded" fxHide.lt-lg>
    <mat-icon svgIcon="menu"></mat-icon>
  </button>

  <button mat-icon-button class="toggle-sidebar-opened" aria-label="Close menu" title="Close menu"
    aria-expanded="true"
    aria-controls="navbar-vertical-2"
    [attr.aria-label]="'generic.menu_open' | translate"
    data-e2e="style-2-opened"
    (click)="toggleSidebarOpened()" fxHide.gt-md>
    <mat-icon svgIcon="arrow_back"></mat-icon>
  </button>

</div>

<div  class="navbar-content" fusePerfectScrollbar
  [fusePerfectScrollbarOptions]="{suppressScrollX: true}">
  <fuse-navigation layout="vertical" role="navigation"></fuse-navigation>
</div>
